export default __webpack_public_path__ + "static/media/stufflayout-glasses.64a0d826.png";